import { getJquery } from '../js/util'

let $ = getJquery()

export default {
	init() {
		// sliders
		$('.home-slider').slick({
			arrows: false,
			dots: true,
			infinite: true,
			fade: true,
			autoplay: true,
			autoplaySpeed: 6000,
			speed: 1000,
		})
		$('.testimonial-slider').slick({
			arrows: false,
			autoplay: true,
			fade: true,
			infinite: true,
		})
		$('.featured-products-slider').slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: true,
			arrows: true,
			prevArrow:
				'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
			nextArrow:
				'<button class="slick-next" aria-label="Next" type="button">Next</button>',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						arrows: false,
					},
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		})

		//NEW USER ACTIVATION THROUGH GFORM EMAIL (REGISTER USER)
		//Update link href to not go to wp-login.php
		let $content = $('#content')
		if ($content.length) {
			setTimeout(() => {
				$('.lead-in a:first-of-type, .view a:first-of-type').attr(
					'href',
					'my-account'
				)
				console.log('workign')
			}, 399)
		}
	},
	finalize() {},
}
